module.exports = __webpack_public_path__ + "static/media/service_industry.c85f7594.png";